import React from 'react';
import { Button } from '../Button/Button';
import { Card, Pic, Name, Wrapper, PLink } from './ProjectCard'

export default function Resume(props) {

    const { summary, imageName, name,link, ...otherProps } = props;

    return (

        <Card>

            <Wrapper>

                <Pic src={require(`../../img/${imageName}`)} alt={`${name}`} />
                <Name>{name}</Name>


            </Wrapper>
            <p> {summary} </p>
            <PLink target="_blank"  href={link}>
                View project &rarr;
            </PLink>



        </Card>

    )

}